var _path, _rect, _rect2, _rect3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompetitiveEdge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 83.5571V43.0054C0 18.9187 19.7878 -0.526558 44.0217 0.0108795C66.8875 0.548309 85.5515 19.2607 85.9912 42.126C86.2355 54.3404 81.3497 65.431 73.3857 73.3948C65.6172 81.1631 54.8683 86 42.9956 86H2.44293C1.12375 86 0 84.8763 0 83.5571Z",
    fill: "#00531C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 43.6719,
    width: 11.4844,
    height: 21.3281,
    rx: 0.984375,
    stroke: "white",
    strokeWidth: 1.96875
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.1561,
    y: 37.1719,
    width: 11.5951,
    height: 27.8282,
    rx: 0.984375,
    stroke: "white",
    strokeWidth: 1.96875
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50.1875,
    y: 50.2344,
    width: 11.8125,
    height: 14.7656,
    rx: 0.984375,
    stroke: "white",
    strokeWidth: 1.96875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0262 26.5002L45.0254 26.5009L45.0262 26.5002ZM42.2801 23.2639C41.8163 22.2305 40.3491 22.2305 39.8852 23.2639L38.9145 25.4268L36.5575 25.6817C35.4313 25.8034 34.9779 27.1988 35.8174 27.9593L37.5745 29.5509L37.0885 31.8713C36.8563 32.98 38.0433 33.8424 39.026 33.279L41.0827 32.0998L43.1393 33.279C44.122 33.8424 45.309 32.98 45.0768 31.8713L44.5909 29.5509L46.3479 27.9593C47.1874 27.1988 46.734 25.8034 45.6079 25.6817L43.2508 25.4268L42.2801 23.2639ZM41.4091 31.9126C41.4089 31.9127 41.4088 31.9128 41.4086 31.9129L41.4091 31.9126L41.0827 31.3433L41.4091 31.9126Z",
    stroke: "#EBFF00",
    strokeWidth: 1.96875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitiveEdge);
export default __webpack_public_path__ + "static/media/CompetitiveEdge.89d42da6e82cb10ec5c16f1eb79016fa.svg";
export { ForwardRef as ReactComponent };